
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { UIMixin } from "../../../mixins/uiMixin";
import { createSelector } from "reselect";
import { addEventCompareConflicts } from '../../../helpers/sport/betslip';
import { TitoAcceptBet, TitoCashoutAcceptBet } from "../../../actions/terminal";
import Zergling from '../../../helpers/zergling';
import { GetOddsFormat } from "../../../helpers/selectors";

class TicketIn extends Component {
    constructor (props) {
        super(props);
        this.state = {
            scores: []
        };
        this.depositMoney = this.depositMoney.bind(this);
        this.copyToBetSlip = this.copyToBetSlip.bind(this);
        this.matchResult = this.matchResult.bind(this);
    }

    depositMoney () {
        return () => {
            let {data} = this.props.data;
            this.props.dispatch(TitoAcceptBet({barcode: data.barcode.toString(), amount: data.amount, tax_amount: data.tax_amount}));
            this.props.closePopup()();
        };
    }
    cashoutDepositMoney () {
        return () => {
            let {data} = this.props.data;
            this.props.dispatch(TitoCashoutAcceptBet({barcode: data.barcode.toString(), amount: data.cashout_amount}));
            this.props.closePopup()();
        };
    }
    componentDidMount () {
        let arrIds = [];
        this.props.data.data.events.event.map((el) => arrIds.push(el.match_id));
        this.matchResult(arrIds);
    }
    matchResult (gameIds) {
        const requestData = Zergling.getresultV2(gameIds).then((data) => {
            data.details && (data.details.length !== 0 ? this.setState({scores: [...this.state.scores, data.details]}) : null);
        });
        return requestData;
    }
    copyToBetSlip () { //TODO Refactoring
        const command = (selections, games) => ({
            source: "betting",
            what: {
                sport: ['id', 'alias'],
                region: ['id'],
                competition: ['id'],
                game: [],
                market: [],
                event: ["id", "order", "name", "price", "type", "base"]
            },
            where: { game: { id: { "@in": games } }, event: { id: { "@in": selections } } }
        });
        return async () => {
            const { events: { event = [] } } = this.props.data.data;
            const eventIds = event.map(item => item.selection_id);
            const matchIds = event.map(item => item.match_id);
            const fullselectionsTree = (await Zergling.get(command(eventIds, matchIds))).data;
            this.props.closePopup()();
            Object.keys(fullselectionsTree.sport).filter(item => Object.prototype.hasOwnProperty.call(fullselectionsTree.sport, item)).map(item => {
                const sport = fullselectionsTree.sport[item];
                Object.keys(sport.region).filter(item => Object.prototype.hasOwnProperty.call(sport.region, item)).map(item => {
                    const region = sport.region[item];
                    Object.keys(region.competition).filter(item => Object.prototype.hasOwnProperty.call(region.competition, item)).map(item => {
                        const competition = region.competition[item];
                        Object.keys(competition.game).filter(item => Object.prototype.hasOwnProperty.call(competition.game, item)).map(item => {
                            const game = competition.game[item];
                            Object.keys(game.market).filter(item => Object.prototype.hasOwnProperty.call(game.market, item)).map(item => {
                                const market = game.market[item];
                                //this.props.betslipEventsCount.some(eventCount => eventCount === market ? console.log(eventCount, "DONE!!!!!!!!!") : "noooooooo");
                                Object.keys(market.event).filter(item => Object.prototype.hasOwnProperty.call(market.event, item)).map(item => {
                                    const event = market.event[item];
                                    this.props.dispatch(addEventCompareConflicts({
                                        ...game,
                                        alias: sport.alias,
                                        regionId: region.id,
                                        competitionId: competition.id
                                    }, market, event, event.id));
                                });
                            });
                        });
                    });
                });
            });
        };
    }

    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

const mapStateToProps = (_) => {
    let tid = JSON.parse(sessionStorage.getItem('authData')).tid;
    return createSelector(
        [
            state => state.swarmData.data.terminal_balance && state.swarmData.data.terminal_balance.terminals[tid] && state.swarmData.data.terminal_balance.terminals[tid].balance,
            state => state.betslip.events && Object.keys(state.betslip.events),
            GetOddsFormat,
            state => state.user.depositMode,
        ],
        (terminalBalance, betslipEvents, oddsFormat, depositMode) => {
            return {
                terminalBalance,
                betslipEvents,
                oddsFormat,
                depositMode
            };
        }
    );
};

TicketIn.propTypes = {
    data: PropTypes.object,
    closePopup: PropTypes.func,
    terminalBalance: PropTypes.number
};

export default connect(mapStateToProps)(UIMixin({Component: TicketIn}));